export default __webpack_public_path__ + "static/media/green.56a02514.png";